export default {
  FILTER: {
    GENDER: 'gender',
    CATEGORY: 'category',
    TYPE: 'type',
    PRODUCTLINE: 'productline',
    SEASON: 'season',
    THEME: 'theme',
    MARKET_SEGMENT: 'marketsegment',
    AVAILABILITY: 'availability',
    BOUGHT_BY_MARKET: 'boughtByMarket',
    IN_MARKET: 'inMarket',
    IN_STORE: 'inStore',
    IN_REGION: 'inRegion',
    ALL_AVAILABILITIES: 'allAvailabilities',
    COMING_SOON: 'placeholder|comingSoon',
    NEW: 'placeholder|new',
    REGION: 'region',
    MARKET: 'market',
    STORE: 'store',
    IN_STOCK: 'inStock',
    SIZE: 'size',
    HAS_IMAGES: 'hasImages',
    EXCLUDE_FROM_CLOTHING_ALLOWANCE: 'excludeFromClothingAllowance',
    COLLECTION: 'collection',
  },
  FILTER_PARAMS: '{genderId}{categoryId}{typeId}{productlineId}{seasonId}{themeId}{marketsegmentId}{q}{availability}{marketId}{regionId}{storeId}{hasImages}{excludeFromClothingAllowance}{size}',
  RELATED: {
    VARIATIONS: 'variations',
    COMMUNICATION_TOOLS: 'communication-tools',
  },
  CHECK: {
    PRICE: 'price',
    STOCK: 'stock',
  },
  HTTP: {
    ERROR_CODE: {
      retail_pro_not_found: 'Product not found in RPRO',
      retail_pro_unreachable: 'Retail Pro unreachable',
      retail_pro_error: 'Retail Pro error',
      retail_pro_invalid_response: 'Retail Pro invalid response',
      retail_pro_soap_fault: 'SOAP error',
      invalid: {
        marketId: 'Unknown market ID',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/product/product.constant.js